import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { maintenanceGuard } from './guards/maintenance.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'main',
    pathMatch: 'full'
  },
  {
    path: 'login',
    canActivate: [maintenanceGuard],
    loadComponent: () => import('./templates/login-template/login-template.component').then(m => m.LoginTemplateComponent)
  },
  {
    path: 'crear-usuario',
    canActivate: [maintenanceGuard],
    loadComponent: () => import('./templates/create-user-template/create-user-template.component').then(m => m.CreateUserTemplateComponent)
  },
  // BON-1225 — Recupero de contraseña por mail: DESHABILITADO.
  // El link del login ahora abre WhatsApp (ver config.ts / login.component.ts). Las rutas
  // quedan comentadas a proposito, no borradas: los componentes, el servicio
  // (LoginService.resetPassword) y el envio del mail en el backend siguen intactos, asi que
  // para volver a habilitarlo alcanza con descomentar estas dos rutas y apuntar de nuevo
  // goToRecoverPassword() a 'restablecer-password'.
  // Ojo: el mail que manda el backend apunta a /#/nueva-clave, ruta que este front no tiene
  // (aca es 'nueva-password'), asi que si se rehabilita hay que corregir ese link primero.
  // {
  //   path: 'restablecer-password',
  //   canActivate: [maintenanceGuard],
  //   loadComponent: () => import('./templates/reset-password-template/reset-password-template.component').then(m => m.ResetPasswordTemplateComponent)
  // },
  // {
  //   path: 'restablecer-password-finish',
  //   canActivate: [maintenanceGuard],
  //   loadComponent: () => import('./templates/reset-password-finish-template/reset-password-finish-template.component').then(m => m.ResetPasswordFinishTemplateComponent)
  // },
  {
    path: 'nueva-password',
    canActivate: [maintenanceGuard],
    loadComponent: () => import('./templates/new-password-template/new-password-template.component').then(m => m.NewPasswordTemplateComponent)
  },
  {
    path: 'nueva-password-finish',
    canActivate: [maintenanceGuard],
    loadComponent: () => import('./templates/new-password-finish-template/new-password-finish-template.component').then(m => m.NewPasswordFinishTemplateComponent)
  },
  {
    path: 'mantenimiento',
    loadComponent: () => import('./templates/maintenance-template/maintenance-template.component').then(m => m.MaintenanceTemplateComponent)
  },
  {
    path: 'main',
    canActivate: [maintenanceGuard],
    loadComponent: () => import('./templates/main-template/main-template.component').then(m => m.MainTemplateComponent),
    children: [
      {
        path: '',
        redirectTo: 'inicio',
        pathMatch: 'full'
      },
      // Rutas públicas (sin login)
      {
        path: 'inicio',
        loadComponent: () => import('./templates/home-template/home-template.component').then(m => m.HomeTemplateComponent)
      },
      {
        path: 'productos',
        loadComponent: () => import('./templates/products-template/products-template.component').then(m => m.ProductsTemplateComponent)
      },
      {
        path: 'producto/:id',
        loadComponent: () => import('./templates/product-detail-template/product-detail-template.component').then(m => m.ProductDetailTemplateComponent)
      },
      {
        path: 'novedades',
        loadComponent: () => import('./templates/news-template/news-template.component').then(m => m.NewsTemplateComponent)
      },
      {
        path: 'sobre-nosotros',
        loadComponent: () => import('./templates/about-template/about-template.component').then(m => m.AboutTemplateComponent)
      },
      // Rutas protegidas (requieren login)
      {
        path: 'ofertas',
        canActivate: [authGuard],
        loadComponent: () => import('./templates/offers-template/offers-template.component').then(m => m.OffersTemplateComponent)
      },
      {
        path: 'packs',
        canActivate: [authGuard],
        loadComponent: () => import('./templates/packs-template/packs-template.component').then(m => m.PacksTemplateComponent)
      },
      {
        path: 'lista-de-precios',
        canActivate: [authGuard],
        loadComponent: () => import('./templates/price-list-template/price-list-template.component').then(m => m.PriceListTemplateComponent)
      },
      {
        path: 'nuevo-pedido',
        canActivate: [authGuard],
        loadComponent: () => import('./templates/new-order-template/new-order-template.component').then(m => m.NewOrderTemplateComponent)
      },
      {
        path: 'pedido-finalizado',
        canActivate: [authGuard],
        loadComponent: () => import('./templates/order-finish-template/order-finish-template.component').then(m => m.OrderFinishTemplateComponent)
      },
      {
        path: 'pedido-exitoso',
        canActivate: [authGuard],
        loadComponent: () => import('./templates/order-success-template/order-success-template.component').then(m => m.OrderSuccessTemplateComponent)
      },
      {
        path: 'pedido-error',
        canActivate: [authGuard],
        loadComponent: () => import('./templates/order-error-template/order-error-template.component').then(m => m.OrderErrorTemplateComponent)
      },
      {
        path: 'pago-pedido',
        canActivate: [authGuard],
        loadComponent: () => import('./templates/order-payment-template/order-payment-template.component').then(m => m.OrderPaymentTemplateComponent)
      },
      {
        path: 'mis-pedidos',
        canActivate: [authGuard],
        loadComponent: () => import('./templates/order-list-template/order-list-template.component').then(m => m.OrderListTemplateComponent)
      },
      {
        path: 'mis-pedidos/:id',
        canActivate: [authGuard],
        loadComponent: () => import('./templates/order-detail-template/order-detail-template.component').then(m => m.OrderDetailTemplateComponent)
      },
      {
        path: 'resumen-pedido',
        canActivate: [authGuard],
        loadComponent: () => import('./templates/order-resume-template/order-resume-template.component').then(m => m.OrderResumeTemplateComponent)
      },
      {
        path: 'recibos',
        canActivate: [authGuard],
        loadComponent: () => import('./templates/receipt-template/receipt-template.component').then(m => m.ReceiptTemplateComponent)
      },
      {
        path: 'recibos-resumen',
        canActivate: [authGuard],
        loadComponent: () => import('./templates/receipt-resume-template/receipt-resume-template.component').then(m => m.ReceiptResumeTemplateComponent)
      },
      {
        path: 'contabilidad',
        canActivate: [authGuard],
        loadComponent: () => import('./templates/accounting-template/accounting-template.component').then(m => m.AccountingTemplateComponent)
      },
      {
        path: 'mi-cuenta',
        canActivate: [authGuard],
        loadComponent: () => import('./templates/my-account-template/my-account-template.component').then(m => m.MyAccountTemplateComponent)
      },
      {
        path: 'configuracion',
        canActivate: [authGuard],
        loadComponent: () => import('./templates/configuration-template/configuration-template.component').then(m => m.ConfigurationTemplateComponent)
      },
      {
        path: 'configuracion-marca',
        canActivate: [authGuard],
        loadComponent: () => import('./templates/brand-config-template/brand-config-template.component').then(m => m.BrandConfigTemplateComponent)
      },
    ]
  },
  {
    path: '**',
    redirectTo: 'main'
  }
];
